import script from "./Book.vue?vue&type=script&setup=true&lang=js"
export * from "./Book.vue?vue&type=script&setup=true&lang=js"

import "./Book.vue?vue&type=style&index=0&id=6cbf54a2&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/shamudeen/shamudeen/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cbf54a2"]])

export default __exports__